/**
 * The Loading component, used while resources load
 * Keep this component as similar as possible to the resource page importing it
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Card, CardTitle, CardBody } from "reactstrap";
import cuttingContour from "../../../assets/images/icons/cutting-contour.svg";
import cuttingRectangular from "../../../assets/images/icons/cutting-rectangular.svg";
import cuttingExtempted from "../../../assets/images/icons/cutting-extempted.svg";

import { FILEEDITOR } from "../../FileUploadEditorForm/utils/fileEditor";
import checkMarkSVG from "../../../assets/images/icons/checkmark.svg";
import { useFormContext, useWatch } from "react-hook-form";

const CuttingTab = ({ editorTypeId }, context) => {
  const editorData = FILEEDITOR[editorTypeId];
  const { register, control, setValue } = useFormContext();
  const selectedCutting = useWatch({
    control,
    name: "cutting",
  });

  const renderPopoverContent = (key) => {
    if (key === "rectangular") {
      return context.t("Cutting.Rectangular.Popover");
    } else if (key === "outline") {
      return context.t("Cutting.Outline.Popover");
    } else if (key === "exempted") {
      return context.t("Cutting.Exempted.Popover");
    }
  };

  const renderCuttingImg = (key) => {
    if (key === "rectangular") {
      return cuttingRectangular;
    } else if (key === "outline") {
      return cuttingContour;
    } else if (key === "exempted") {
      return cuttingExtempted;
    } else {
      return "https://cdn.myfolie.de/media/20x20.png";
    }
  };

  return (
    <Container>
      <div className="h4">{context.t("cutting")}</div>
      <Row>
        {editorData?.cuttings?.map((availableCutting) => (
          <Col xs={12} key={availableCutting.key}>
            <Card
              onClick={() => setValue("cutting", availableCutting.key)}
              className={`hv-pointer mb-2 ${
                selectedCutting === availableCutting.key ? "border-success" : ""
              }`}
            >
              <CardBody>
                <Row noGutters>
                  <Col md={2} xs={4}>
                    <div
                      className={
                        "pr-3 laminate-field--icon-container" +
                        (selectedCutting === availableCutting.key
                          ? " selected"
                          : "")
                      }
                    >
                      <img
                        src={renderCuttingImg(availableCutting.key)}
                        alt={availableCutting.key}
                        className={"cutting-field-icon w-100"}
                        loading="lazy"
                      />
                    </div>
                  </Col>
                  <Col md={10} xs={8}>
                    <div className="h5">
                      <input
                        {...register("cutting", { required: true })}
                        type="radio"
                        name="cutting"
                        value={availableCutting.key}
                        style={{ display: "none" }}
                        id={availableCutting.key}
                      />
                      {context.t(availableCutting.key)}
                    </div>
                    <p className="text-secondary d-md-block d-none">
                      {renderPopoverContent(availableCutting.key)}
                    </p>
                  </Col>
                  {selectedCutting === availableCutting.key && (
                    <img
                      src={checkMarkSVG}
                      alt={"selected_option"}
                      className="laminate-field--checkmark"
                      loading="lazy"
                      style={{
                        position: "absolute",
                        right: "0.5rem",
                        top: "0.75rem",
                      }}
                    />
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
      <div className="d-md-none d-block">
        {editorData?.cuttings?.map((availableCutting) => (
          <p className="text-secondary">
            <strong>{context.t(availableCutting.key)}:</strong>{" "}
            {renderPopoverContent(availableCutting.key)}
          </p>
        ))}
      </div>
    </Container>
  );
};

/**  define proptype for the 'translation' function  */
CuttingTab.contextTypes = {
  t: PropTypes.func,
};
export default CuttingTab;
